import { render } from "./List_Projetos.vue?vue&type=template&id=2c441084"
import script from "./List_Projetos.vue?vue&type=script&lang=js"
export * from "./List_Projetos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\api_adm_unimagem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__